import { styled } from "@monolith-forensics/monolith-ui";
import { File } from "../../files.types";
import { UploadQueueItem } from "../../Hooks/useUploadQueue";
import { PhotoGridItem } from "./PhotoGridItem";

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 20px;
`;

export type PhotoGridEntry = { file: File; upload?: UploadQueueItem };

export type PhotoGridProps = {
  entries: PhotoGridEntry[];
  onView: (file: File) => void;
  onDownload?: (file: File) => void;
  /** Omit to render no delete affordance. */
  onDelete?: (file: File) => void;
  /** Omit to render no rename affordance. */
  onRename?: (file: File) => void;
  /** Wire to `useUploadQueue().dismiss` so failed uploads can be cleared. */
  onDismiss?: (uuid: string) => void;
  /** Called when a photo fails to load, e.g. its signed link expired. */
  onImageError?: (file: File) => void;
  emptyMessage: string;
};

export const PhotoGrid = ({
  entries,
  onView,
  onDownload,
  onDelete,
  onRename,
  onDismiss,
  onImageError,
  emptyMessage,
}: PhotoGridProps) => {
  if (entries.length === 0) {
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>{emptyMessage}</div>
    );
  }

  return (
    <StyledGrid className="photo-grid">
      {entries.map(({ file, upload }) => (
        <PhotoGridItem
          key={upload?.uuid ?? file.uuid}
          file={file}
          upload={upload}
          onView={onView}
          onDownload={onDownload}
          onDelete={onDelete}
          onRename={onRename}
          onDismiss={onDismiss}
          onImageError={onImageError}
        />
      ))}
    </StyledGrid>
  );
};
